// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1qwRx","signatureBlock":"Footer_signatureBlock__3xp9_","signature":"Footer_signature__1voAk"};